var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb"},[(_vm.displayBackButton)?_c('i',{staticClass:"fa fa-chevron-circle-left back-btn-2",attrs:{"aria-hidden":"true"},on:{"click":_vm.goBack}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }